const campaigns = {
  getlist: 'AdsCampaign/getlist',
  getAll: 'AdsCampaign/getall',
  get: 'AdsCampaign/get',
  add: 'AdsCampaign/add',
  update: 'AdsCampaign/update',
  remove: 'AdsCampaign/remove',
}
export default campaigns
